
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { Dimension, NaturallyOrderedValue } from 'crossfilter2';
import { Autocomplete as AutocompleteInput, TextField} from '@mui/material';
import { IChart, IAutocompleteProps } from 'utils/chartsUtils';
import { Log } from 'utils/types';

type Option = {
  label: NaturallyOrderedValue
  key: NaturallyOrderedValue
  value: unknown
}

const Autocomplete = forwardRef<IChart, IAutocompleteProps>(
  (
    {
      cf,
      logKey,
      title,
      defaultDimensionName,
      dimensionFilter,
      onFilter,
    }: IAutocompleteProps,
  ) => {
      
    const [options, setOptions] = useState<Option[]>([]);
    const [dimension, setDimension] = useState<Dimension<Log, Date>>();


    const onChange = (e: any, value: any) => {
        if (value) {
            dimension?.filter(value.label)
        }
        else {
            dimension?.filterAll()
        }
        if (onFilter) onFilter();
    }

    const isDimensionArray = useCallback(() => {
        const logs = cf?.ndx.allFiltered();
        if (logs && logs.length > 0) {
        return Array.isArray(logs[0][logKey as keyof Log]);
        }
        return false;
    }, [cf?.ndx, logKey]);

    const defaultDimensionFilter = useCallback(
        (log: { [key: string]: any }) => {
        if (logKey && (log[logKey] || log[logKey] === false)) {
            switch (logKey) {
            case 'preselection':
                return log[logKey];
            default:
                return log[logKey].toString();
            }
        }

        return defaultDimensionName || 'Inconnu';
        },
        [defaultDimensionName, logKey],
    );

    const update = useCallback(() => {
        if (!cf) return;

        const newDimension = cf.ndx.dimension((log) => {
            if (dimensionFilter) {
            return dimensionFilter(log);
            }
            return defaultDimensionFilter(log);
        }, isDimensionArray());

        setDimension((prevState) => {
            prevState?.dispose();
            return newDimension;
        });
          
        const newGroup = newDimension.group();
        setOptions(() => newGroup.all().map((element) => ({...element, label: element.key})))        
    }, [cf, defaultDimensionFilter, dimensionFilter, isDimensionArray]);


    useEffect(() => {
        update();
    }, [update]);

    return (
      <div>
        <strong className="Chart-title">{title}</strong>
        <div className="reset"/>
        <AutocompleteInput options={options} renderInput={(params) => <TextField {...params} label=""/>} onChange={onChange}/>
      </div>
    );
  },
);

export default Autocomplete;


